import { Component, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { OlPdfAcceptanceComponent } from 'src/app/components/ol-pdf-acceptance/ol-pdf-acceptance.component';
import { IAcceptanceData } from 'src/app/models/acceptance.data.model';
import { ITemplateAcceptedOffer } from 'src/app/models/templates.model';
import { AuthService } from 'src/app/services/auth.service';
import { PdfService } from 'src/app/services/pdf.service';
import { PropostaSalarialService } from 'src/app/services/proposta-salarial.service';
import { SlideBaseComponent } from 'src/app/shared/slider/slide/slide-base.component';

@Component({
  selector: 'hr-dynamic-accepted-offer',
  templateUrl: './dynamic-accepted-offer.component.html',
  styleUrls: ['./dynamic-accepted-offer.component.scss'],
})
export class DynamicAcceptedOfferComponent extends SlideBaseComponent {
  @ViewChild('olPdfAcceptance') olPdfAcceptance!: OlPdfAcceptanceComponent;
  override initialValue: ITemplateAcceptedOffer;
  acceptanceData: Partial<IAcceptanceData>;
  nomeProfissional: string;
  logoUrl: string;
  isDownloading = false;

  constructor(
    private formBuilder: FormBuilder,
    private propostaService: PropostaSalarialService,
    authService: AuthService,
    private pdfService: PdfService
  ) {
    super();
    this.nomeProfissional = propostaService.getView().nomeCompleto;
    this.logoUrl = authService.logoUrl;
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.getAcceptanceData();
  }

  protected override onInit(): void { }

  protected onDestroy(): void { }

  private getAcceptanceData(): void {
    this.propostaService.getAcceptanceData().subscribe({
      next: (acceptanceData) => {
        this.acceptanceData = acceptanceData;
      },
      error: (err) => {
        return null;
      },
    });
  }

  protected initForm(): void {
    this.form = this.formBuilder.group({
      slideName: [null, [Validators.required, Validators.maxLength(20)]],
      title: [null, [Validators.required, Validators.maxLength(40)]],
      description: [null, [Validators.required, Validators.maxLength(1500)]],
      firstNote: [null, [Validators.required, Validators.maxLength(1500)]],
      secondNote: [null, [Validators.required, Validators.maxLength(1500)]],
      firstImage: [null, [Validators.required]],
      firstImageUrl: [null, [Validators.required]],
    });
  }

  async downloadPdf() {
    if (this.isDownloading) return;
    this.isDownloading = true;
    try {
      await this.pdfService.downloadPdf(this.olPdfAcceptance);
    } catch (err) {
      // keep UX simple: stop spinner on error; caller/service handles logging
    } finally {
      this.isDownloading = false;
    }
  }
}
